import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_LocoParents = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_LocoParents' className='file-pdf-document'>
            <div className='file-template'>




                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date:</span></td>
                        <td className='w-250'><span className='eleHeader'>Consumer Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Record No:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtDate" name="txtDate" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtConsumerName" name="txtConsumerName" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtRecordNo" name="txtRecordNo" className='add-only' /></td>
                    </tr>
                </table>

                <p>
                    This consumer resides with <input type="text" placeholder="(insert names(s) and relationship)" id="txtConsumerName_1" name="txtConsumerName_1" className='add-only w-250 custom-add-only' />, Who is/are primarily responsible for the care of this consumer and qualifies them to act In Loco Parentis.

                </p>
                <p>
                    The following circumstances support In Loco Parentis (examples include person's name is listed on Medicaid card, person signs school paperwork, person accesses medical care, etc.,):


                    <textarea id="txtcircumstances" name="txtcircumstances" className='add-only'></textarea>


                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-500">Signature of Individual identified as Loco Parentis:</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-500">Staff Signature:</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                </table>




            </div>
        </form>

    )
}  
